// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const brickKiln = defineModel({
  id: "brick-kiln",
  batchId: "future",
  name: "Brick kiln",
  tags: ["building","brick","kiln","low-poly","age-of-mcp","future"],
  summary: "Fires clay into bricks, tiles and pottery bisque — one kiln, several products.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.45, 1.2), color: "#9c4a32", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a3826", position: [-0.75, 0.365, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a3826", position: [0.75, 0.365, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a3826", position: [-0.75, 0.365, 0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#7a3826", position: [0.75, 0.365, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.85, 1.2), color: "#9c4a32", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [-0.75, 0.565, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [0.75, 0.565, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [-0.75, 0.565, 0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [0.75, 0.565, 0.6] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [-0.775, 0.675, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [0.775, 0.675, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [-0.775, 0.675, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.35, 4), color: "#6b4a26", position: [0.775, 0.675, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.85, 1.2), color: "#9c4a32", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [-0.75, 0.565, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [0.75, 0.565, -0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [-0.75, 0.565, 0.6] },
      { geometry: new THREE.BoxGeometry(0.1, 0.85, 0.1), color: "#7a3826", position: [0.75, 0.565, 0.6] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.793485), color: "#7a4a36", position: [0, 1.15, 0.33], rotation: [0.451453, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.793485), color: "#7a4a36", position: [0, 1.15, -0.33], rotation: [-0.451453, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#5a3526", position: [0, 1.31, 0] },
      { geometry: new THREE.BoxGeometry(0.32, 0.3, 0.06), color: "#2c2a28", position: [0, 0.31, 0.61] },
      { geometry: new THREE.CylinderGeometry(0.16, 0.16, 0.06, 8, 1, false, 0, 3.141593), color: "#2c2a28", position: [0, 0.46, 0.61], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.5, 0.2), color: "#7a3826", position: [0.42, 1.24, -0.2] },
      { geometry: new THREE.BoxGeometry(0.26, 0.06, 0.26), color: "#9c4a32", position: [0.42, 1.51, -0.2] },
      { geometry: new THREE.BoxGeometry(0.36, 0.07, 0.2), color: "#9c4a32", position: [-0.68, 0.175, 0.52] },
      { geometry: new THREE.BoxGeometry(0.36, 0.07, 0.2), color: "#9c4a32", position: [-0.64, 0.245, 0.52] },
      { geometry: new THREE.BoxGeometry(0.36, 0.07, 0.2), color: "#9c4a32", position: [-0.68, 0.315, 0.52] },
      { geometry: new THREE.BoxGeometry(0.36, 0.07, 0.2), color: "#9c4a32", position: [-0.64, 0.385, 0.52] },
    ] },
  ],
  animations: [],
});
